module.exports = __webpack_public_path__ + "img/btcest-query.647e5cd7.png";